import React, { FC, useEffect, useMemo } from 'react';
import { TemplatesGrid } from '../TemplateGrids/TemplatesGrid';
import s from './TemplatesPage.scss';
import { Footer } from '../Footer/Footer';
import { TemplatesRepositoryContextProvider } from '../../contexts/TemplatesRepositoryContext';
import { useTranslation } from '@wix/wix-i18n-config';
import { useInitialState } from '../../contexts/InitialStateContext';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { CategoryTabs } from '../CategoryTabs/CategoryTabs';
import { useSelectedCategoryId } from '../../hooks/useSelectedCategoryId';
import { templatesPageDataHooks } from './TemplatesPage.dataHooks';

interface TemplatesPageProps {}

const TemplatesPage: FC<TemplatesPageProps> = () => {
  const initialState = useInitialState();
  const { t } = useTranslation();
  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.reportTemplatesPageView();
  }, []);

  const categories = useMemo(
    () => initialState.book?.categories ?? [],
    [initialState.book],
  );

  const isStudioUser =
    initialState.userData.isLoggedIn &&
    initialState.userData.profile.isStudioAccount;

  const selectedCategoryId = useSelectedCategoryId({ categories });

  return (
    <main data-hook={templatesPageDataHooks.container()} className={s.main}>
      <h1 className={s.heading}>
        {t(`app.main.header${isStudioUser ? '' : '.notStudioUser'}`)}
      </h1>
      <CategoryTabs
        biLogger={biLogger}
        categories={categories}
        selectedCategoryId={selectedCategoryId}
      />
      <TemplatesRepositoryContextProvider categoryId={selectedCategoryId}>
        <TemplatesGrid />
      </TemplatesRepositoryContextProvider>
      <Footer />
      {/* <ScrollTopButton />*/}
    </main>
  );
};

export default TemplatesPage;
